// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuditRouteImport } from './routes/audit'
import { Route as TelescopeRouteImport } from './routes/Telescope'
import { Route as PeaqueRouteImport } from './routes/Peaque'
import { Route as FairyHomesRouteImport } from './routes/FairyHomes'
import { Route as R1MindRouteImport } from './routes/1Mind'
import { Route as IndexRouteImport } from './routes/index'
import { Route as BriefSlugRouteImport } from './routes/brief.$slug'

const AuditRoute = AuditRouteImport.update({
            id: '/audit',path: '/audit',getParentRoute: () => rootRouteImport
          })
const TelescopeRoute = TelescopeRouteImport.update({
            id: '/Telescope',path: '/Telescope',getParentRoute: () => rootRouteImport
          })
const PeaqueRoute = PeaqueRouteImport.update({
            id: '/Peaque',path: '/Peaque',getParentRoute: () => rootRouteImport
          })
const FairyHomesRoute = FairyHomesRouteImport.update({
            id: '/FairyHomes',path: '/FairyHomes',getParentRoute: () => rootRouteImport
          })
const R1MindRoute = R1MindRouteImport.update({
            id: '/1Mind',path: '/1Mind',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const BriefSlugRoute = BriefSlugRouteImport.update({
            id: '/brief/$slug',path: '/brief/$slug',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,R1MindRoute: R1MindRoute,FairyHomesRoute: FairyHomesRoute,PeaqueRoute: PeaqueRoute,TelescopeRoute: TelescopeRoute,AuditRoute: AuditRoute,BriefSlugRoute: BriefSlugRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)